import { Component, SimpleChanges, Input } from '@angular/core';
import { RegisterModalPage } from '../../shared/register-modal/register-modal';
import { LoginModalPage } from '../../shared/login-modal/login-modal';
import { game, errorHelper, draw, combType, ConfigService, SharedService, VirtualBetPanelService } from 'baseline-lib';
import { Global } from '../../../global/global';
import { ModalController } from 'ionic-angular';

/**
 * Generated class for the VirtualGameComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'virtual-game',
  templateUrl: 'virtual-game.html'
})
export class VirtualGameComponent {

  @Input() gameObj: game;
  _imageUrl: string;
  drawsub: any;
  prizelevelsub: any;
  _gameid: number;
   error?: errorHelper;
  _selectedDraw : draw;
  public _combinationType = combType;
  
  constructor(private _configService: ConfigService,
    private _virtualBetPanelService : VirtualBetPanelService, public globalData : Global,
    public modalCtrl : ModalController) 
    {
      this._imageUrl = this._configService.getImageUrl();
      //this.gameObj = this.navParams.get("gameObj");
    } 


    ionViewDidLoad() {
      console.log('ionViewDidLoad VirtualGamePage');
    }

    ngOnChanges(changes: SimpleChanges) {
      if (changes.gameObj) {
        this.gameObj =  changes.gameObj.currentValue as game;
      }
    }

    ngOnInit() {
      //initilise error message ;    
      this._virtualBetPanelService.clearallBetPanels();
    }

    loginClicked()
    {
      let profileModal = this.modalCtrl.create(LoginModalPage);
      profileModal.present();    
    }

    registerClicked()
    {
      let registerModal = this.modalCtrl.create(RegisterModalPage);
      registerModal.present();
    }

    // openMenuPage(){
    //   this.navCtrl.pop();
    // }

    // openBetSlipPage(){
    //   this.navCtrl.push(VirtualBetslipPage);
    // }
}



// WEBPACK FOOTER //
// ./src/app/virtual-sports/virtual-game/virtual-game.ts